gsap.registerPlugin(ScrollTrigger)

//initialize title animation
var titlesTl = []
var hpMobile = false;
var hpTablet = false;
function initTitleAnimation() {
    const titles = document.querySelectorAll('.mobile-bath-fragrance .img-frame h3')
    titles.forEach((title) => {
        const titleTl = gsap.timeline({
            scrollTrigger: {
                trigger: title,
                scrub: true,
                end: "+=70%",
            }
        })
        titleTl.fromTo(title, { top: "74%" }, {
            top: "15%"

        })
        titlesTl.push(titleTl)
    })
}
function checkViewportAnimation() {
    var viewportWidth = window.viewportSize.getWidth();
    if (viewportWidth <= 430) {
        if (!hpMobile) {
            titlesTl.forEach((timeline) => {
                timeline.kill()
                timeline.vars.scrollTrigger.trigger.style = ""
            })
            titlesTl = []
        }
        hpMobile = true;
        hpTablet = false;
    } else {
        if (!hpTablet) {
            initTitleAnimation()

        }
        hpMobile = false;
        hpTablet = true;
    }
}
checkViewportAnimation()
window.addEventListener('resize', checkViewportAnimation)